module.exports = __webpack_public_path__ + "static/media/Tejo.9a734292.svg";